import axios from '@utils/api/axios';
import { endpoints } from '../endpoints';
import { MilestoneToBeBilled } from './types/billing.type';
import { CreateBillingOrderRequest } from './types/create-billing.type';
import { ChoicesStatusMilestone } from '@/types/milestone.interface';
import { BillingOrderDetail } from './types/billing-order-detail.type';

export interface MilestonesToBeBilledQueryParams {
  organizationId: string;
  month?: number;
  year?: number;
  status?: ChoicesStatusMilestone;
  search?: string;
}

export async function fetchMilestonesToBeBilled(filters: MilestonesToBeBilledQueryParams) {
  const response = await axios.get<MilestoneToBeBilled[]>(
    endpoints.billing.milestonesToBeBilledByOrg(),
    {
      params: { ...filters },
    }
  );
  return response.data;
}

export async function createBillingOrder(billingOrderPayload: CreateBillingOrderRequest) {
  const response = await axios.post(endpoints.billing.createBillingOrder, billingOrderPayload);
  return response.data;
}

export async function fetchBillingOrderById(orderId: string) {
  const response = await axios.get<BillingOrderDetail>(
    endpoints.billing.getBillingOrderById(orderId)
  );
  return response.data;
}
